export const shortTrimFor = ({ tracking }) => {
    const { trim } = tracking || {}
    const { title } = trim || {}
    return title || ''
}